import * as React from "react";
import DocumentTitle from "../../misc/components/DocumentTitle";
import { Form } from "informed";
import { UserForm } from "./UserForm";
import { GlobalAuthorization } from "../../misc/components/Authorization";
import { PermissionEnum } from "../../misc/api/ApiPermissionEnum";
import { useSecurityContext } from "../../Core/SecurityContext";

export const CreateUserScreen = () => {
    const title = "Create User";
    const { currentUserPermissions } = useSecurityContext();

    return (
        <DocumentTitle title={`${title} | Vitalograph Web Portal`}>
            <GlobalAuthorization permissionId={PermissionEnum.CreateUsers} currentPermissions={currentUserPermissions}>
                <Form noValidate>
                    <UserForm header={title} />
                </Form>
            </GlobalAuthorization>
        </DocumentTitle>
    );
}